import { Button } from "@mui/material";
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { importData } from "../services/project.service";
import { useDispatch } from "react-redux";
import { toggleAlert } from "../store/resuders/app.reducer";


export interface IProps {
    tab: string;
    language?:string;
    id:number;
    close: () => void;
    isglobal: boolean;
}
export const ImportData = ({
    tab,
    close,
    language= 'english',
    id = 1,
    isglobal,
}: IProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const selectFile = () => {
        document.getElementById('selectFile')?.click();
    }

    const fileChanged = async (e: any) => {
        try {
            const result: any = await importData(id, tab, language, e?.target?.files[0], isglobal);
    
            if (result?.code === "success") {
                close();
                dispatch(toggleAlert(t("Imported successfully")));
            } else {
                close();
                // Show error message if the result indicates failure
                const errorMessage = result?.data?.messages?.join(',') || t("An error occurred during import.");
                dispatch(toggleAlert(errorMessage)); // Dispatch toggleAlert
            }
        } catch (error) {
            // Handle unexpected errors
            dispatch(toggleAlert(t("An unexpected error occurred. Please try again."))); // Dispatch toggleAlert
        }
    };

    return (
        <div className="db p-5 text-center">
            <div className="db">
                <InfoOutlinedIcon style={{ fontSize: '53px', color: '#FD5900' }} />
            </div>
            <div className="db mt-16 calc-mos f-w-700">
                {t('Warning')}
            </div>
            <span className="f-w-700">
                {t('Importing might override some of the existing {tab}.').replace('{tab}',tab)}
                <br/>
                {t('Do you want to continue?')}
            </span>
            <div className="db mt-24">
                <div className="flex-center justify-center segment-editor-save-buttons gap-32">
                    <Button
                        variant={'contained'}
                        color="secondary"
                        className='max-h-30'
                        onClick={close}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        variant={'contained'}
                        color="primary"
                        onClick={selectFile}
                        className='max-h-30'
                    >
                        {t("Import")}
                    </Button>
                </div>
            </div>
            <input type="file" onChange={fileChanged} className="hidden" id="selectFile"></input>
        </div>
    )
}